module.exports = __webpack_public_path__ + "img/rad-conv-Sala-Analogico-HF-1.aeb847ab.png";